import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import { RootState } from '../store';

export interface PortalPlatformState {
    dismissedIds: {
        banks: number[];
        wallets: number[];
    };
    dismissedWhitelistRequests: {
        banks: number[];
        wallets: number[];
    };
    initiatedWhitelistRequests: {
        banks: number[];
        wallets: number[];
    };
}

export const defaultOpenPositionState: PortalPlatformState = {
    dismissedIds: {
        banks: [],
        wallets: []
    },
    dismissedWhitelistRequests: {
        banks: [],
        wallets: []
    },
    initiatedWhitelistRequests: {
        banks: [],
        wallets: []
    }
};

const initialState: PortalPlatformState = defaultOpenPositionState;

export const portalPlatformSlice = createSlice({
    name: 'portalPlatform',
    initialState,
    reducers: {
        dismissBankId: (state, action: PayloadAction<number>) => {
            state.dismissedIds.banks = Array.from(new Set([...state.dismissedIds.banks, action.payload]));
        },
        dismissWalletId: (state, action: PayloadAction<number>) => {
            state.dismissedIds.wallets = Array.from(new Set([...state.dismissedIds.wallets, action.payload]));
        },
        dismissBankRequestId: (state, action: PayloadAction<number>) => {
            state.dismissedWhitelistRequests.banks = Array.from(
                new Set([...state.dismissedWhitelistRequests.banks, action.payload])
            );
        },
        dismissWalletRequestId: (state, action: PayloadAction<number>) => {
            state.dismissedWhitelistRequests.wallets = Array.from(
                new Set([...state.dismissedWhitelistRequests.wallets, action.payload])
            );
        },
        initiateBankRequestId: (state, action: PayloadAction<number[]>) => {
            state.initiatedWhitelistRequests.banks = action.payload;
        },
        initiateWalletRequestId: (state, action: PayloadAction<number[]>) => {
            state.initiatedWhitelistRequests.wallets = action.payload;
        },
        removeBankRequestId: (state, action: PayloadAction<number>) => {
            state.initiatedWhitelistRequests.banks = state.initiatedWhitelistRequests.banks.filter(
                (id) => id !== action.payload
            );
        },
        removeWalletRequestId: (state, action: PayloadAction<number>) => {
            state.initiatedWhitelistRequests.wallets = state.initiatedWhitelistRequests.wallets.filter(
                (id) => id !== action.payload
            );
        },
        resetRequestIds: (state) => {
            state.initiatedWhitelistRequests = {
                banks: [],
                wallets: []
            };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => initialState);
    }
});

export const {
    dismissBankId,
    dismissWalletId,
    dismissBankRequestId,
    dismissWalletRequestId,
    initiateBankRequestId,
    initiateWalletRequestId,
    removeBankRequestId,
    removeWalletRequestId,
    resetRequestIds
} = portalPlatformSlice.actions;
export const selectDismissedIds = (state: RootState) => state.portalPlatform.dismissedIds;
export const selectDismissedWhitelist = (state: RootState) => state.portalPlatform.dismissedWhitelistRequests;
export const selectInitiatedWhitelist = (state: RootState) => state.portalPlatform.initiatedWhitelistRequests;

export default portalPlatformSlice.reducer;
